const buildCookieRevokeGlobalStyles = (breakpointsMd) => `
  .dp-cookie-policy-button.cc-revoke {
    color: #000000 !important;
    opacity: 0 !important;
    visibility: hidden !important;
    pointer-events: none !important;

    @media (max-width: calc(${breakpointsMd} - 1px)) {
      left: auto !important;
      right: -46px !important;
    }

    &.is-visible-on-footer {
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
    }

    &.is-over-dark-footer {
      color: #ffffff !important;
    }
  }
`

const cookieRevokeGlobalStyles = buildCookieRevokeGlobalStyles('768px')

module.exports = { buildCookieRevokeGlobalStyles, cookieRevokeGlobalStyles }
